import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface OrderItemDto {
    id: string;
    productId: string;
    productName: string;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
}

export interface OrderDto {
    id: string;
    orderNumber: string;
    customerId?: string;
    customerName: string;
    customerEmail: string;
    customerPhone: string;
    subTotal: number;
    shippingFee: number;
    discountAmount: number;
    total: number;
    status: string;
    paymentIntentId: string;
    shippingAddress: string;
    city: string;
    country: string;
    trackingNumber?: string;
    createdAt: string;
    items: OrderItemDto[];
}

export enum OrderStatus {
    Pending = 0,
    Paid = 1,
    Processing = 2,
    Shipped = 3,
    Delivered = 4,
    Cancelled = 5,
    Refunded = 6
}

export interface UpdateOrderStatusDto {
    status: OrderStatus;
    trackingNumber?: string;
}

@Injectable()
export class OrderService {
    private http = inject(HttpClient);
    private apiUrl = environment.apiUrl + '/Orders';

    getAll(): Observable<OrderDto[]> {
        return this.http.get<any>(`${this.apiUrl}`).pipe(map(r => r.data ?? r));
    }

    getById(id: string): Observable<OrderDto> {
        return this.http.get<any>(`${this.apiUrl}/${id}`).pipe(map(r => r.data ?? r));
    }

    updateStatus(id: string, dto: UpdateOrderStatusDto): Observable<any> {
        return this.http.patch(`${this.apiUrl}/${id}/status`, dto);
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }
}
